// extracted by mini-css-extract-plugin
export default {"NavbarContainer":"MobileNavbar_NavbarContainer__EJHok","navElements":"MobileNavbar_navElements__ZIKnR","active":"MobileNavbar_active__0b6xJ"};